import type { Form } from '../../common/types/form';
import { Setting } from '../../common/types/settings';

const groupForm: Form<Setting> = {
  key: 'groups',
  title: 'Gruppen',
  fields: [
    {
      key: 'value',
      label: 'Name',
      fieldTypes: 'text',
      validateIsNotEmpty: true,
    },
  ],
};

export default groupForm;
